'use client';

import { Button, Container, Typography } from '@mui/material';

/**
 * @name Error
 * @param {string} error - Error thrown by UI component
 * @function reset - Function to prompt the user to attempt to recover from the error
 * @description Error UI boundary for a route segment
 * @returns {JSX.Element} ReactElement
 */
export default function Error({ error, reset }) {
  return (
    <Container>
      <Typography variant='body1'>Something went wrong!</Typography>
      <Typography variant='subtitle1'>{error.message}</Typography>
      <Button
        onClick={
          () => reset() // for rerendering component
        }
        aria-label='Please try again'
      >
        Please try again
      </Button>
    </Container>
  );
}
